import { render, staticRenderFns } from "./ProductionUnit.vue?vue&type=template&id=55be5dc9&scoped=true&"
import script from "./ProductionUnit.vue?vue&type=script&lang=js&"
export * from "./ProductionUnit.vue?vue&type=script&lang=js&"
import style0 from "./ProductionUnit.vue?vue&type=style&index=0&id=55be5dc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55be5dc9",
  null
  
)

export default component.exports